<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="dialogForm"
    title="报警详情"
    width="700px"
    :before-close="handleClose"
    :visible.sync="dialogVisible"
  >
    <div class="line"></div>
    <el-form style="margin:0" label-width="100px">
      <el-row>
        <el-col :span="11">
          <el-form-item label="车牌号">
            <el-input class="formInput" size="small" disabled v-model="param.carId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="报警时间">
            <el-input class="formInput" size="small" disabled v-model="param.alarmTime"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="司机">
            <el-input class="formInput" size="small" disabled v-model="param.ctPersonId"></el-input>
            <!-- <el-select size="small" class="formInput" v-model="param.driverId" disabled>
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label "
                :value="item.value"
              />
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="司机电话">
            <el-input class="formInput" size="small" disabled v-model="param.driverTel"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="收运人员">
            <el-select size="small" class="formInput" v-model="param.ctPersonId" disabled>
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label "
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="收运人员电话">
            <el-input class="formInput" size="small" disabled v-model="param.ctPersonTel"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="报警类型">
            <el-select size="small" v-model="param.alarmType" class="input" disabled>
              <el-option
                v-for="item in $storage.getSelectDict('alarmType')"
                :key="item.value"
                :label="item.label "
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="报警地址">
            <el-input class="formInput" size="small" disabled v-model="param.alarmAddress"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="报警详情" prop="remark" size="small">
          <el-input
            type="textarea"
            :rows="3"
            v-model="param.handleDetail"
            style="width:90%"
            disabled
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "notificationDetail",
  data() {
    return {
      dialogVisible: true,
      userList: [],
      param: {
        alarmTime: "",
        numberPlate: "",
        driverId: "",
        driverTel: "",
        ctPersonId: "",
        ctPersonTel: "",
        alarmType: "",
        alarmAddress: "",
        handleDetail: "",
      },
    };
  },
  methods: {
    handleClose(done) {
      refAkarninfo(); //进行新的数据请求
      this.$parent.notificationDetailShow = false;
      done();
    },
    setData(param) {
      this.getUserList();
      this.param = Object.assign({}, param);
      if (this.param.alarmType)
        this.param.alarmType = this.param.alarmType.toString();
    },
    //获取人员list
    getUserList() {
      var that = this;
      that.$util._formPost(
        false,
        that,
        that.ref,
        "",
        api.user_info_list,
        function (_r) {
          let res = _r.data;
          res.forEach((e) => {
            that.userList.push({
              value: e.id,
              label: e.userName,
            });
          });
        }
      );
    },
  },
};
</script>

<style scoped lang='scss'>
.line {
  @include line;
}
.formInput {
  @include formInput(180px);
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
</style>


// WEBPACK FOOTER //
// src/components/notification/notificationDetail.vue